import * as React from "react";
import i18n from "../../../../i18n/i18n";
import {Popup} from "../../../../common/components/shared/popup/popup";
import {ReactComponent as DisableIcon} from "../../../../statics/icons/icon_disable.svg";
import "./disablePopup.scss";
import {HttpError} from "../../../../common/components/shared/httpError/httpError";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../../../common/models/httpError";
import {Api} from "../../../../helpers/api";

interface DisablePopupProps {
    displayPopup: boolean;
    confirm: () => void;
    closePopup: () => void;
    username: string;
    response: AxiosResponse<HttpErrorModel[] | any> | undefined;
    isWaiting: boolean;
}

export default function DisablePopup(props: DisablePopupProps): React.ReactElement {
    const content = <div>
        {i18n.t("administration.disableAction.firstPart")}
        <b>{props.username}</b>
        {i18n.t("administration.disableAction.lastPart")}
    </div>;

    return (
        <Popup
            open={props.displayPopup}
            className="disable-popup popup-with-secondary-button-color"
            header={i18n.t("administration.disableAction.header")}
            secondHeader={i18n.t("administration.disableAction.secondHeader")}
            icon={<DisableIcon/>}
            content={content}
            actionText={i18n.t("administration.disableAction.actionText")}
            action={props.confirm}
            cancel={props.closePopup}
            testId="disable-popup"
            httpError={
                <>
                    {!Api.isSuccess(props.response) && (
                        <HttpError
                            response={props.response}
                            cause={i18n.t("administration.errors.disableErrorSuffix")}
                            translatedFields={{
                                id: i18n.t("administration.errors.idNotFound")
                            }}
                        />
                    )}
                </>
            }
            isWaiting={props.isWaiting}
        />
    );
}
